<template>
  <el-dialog :class="[currentTheme]" :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" width="320px" :append-to-body="true">
    <div class="main-box main-table tableExport-div">
      <div class="tableExport-form">
        <el-form ref="dataForm" id="dataForm"  :model="configure.listParam" label-width="100px" label-suffix="：">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item  label="导出内容">
                <el-select placeholder="请选择" v-model="exportType" style="width: 130px;">
                  <el-option v-for="item in exportTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>


      <xr-data-table ref="xrDataTable" :configure="dataConfigure"></xr-data-table>

<!--      <el-table-->
<!--        ref="columnSettingTable"-->
<!--        :data="tableData"-->
<!--        :header-cell-style="{'text-align':'center'}"-->
<!--        height="390"-->
<!--        border>-->
<!--        <el-table-column-->
<!--          prop="isShow"-->
<!--          width="80"-->
<!--          label="是否导出">-->
<!--          <template #default="scope">-->
<!--            <div class="table-checkbox" style="text-align: center;">-->
<!--              <el-checkbox v-model="scope.row.isShow" true-label="1" false-label="0"></el-checkbox>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="columnName"-->
<!--          label="列名称">-->
<!--          <template #default="scope">-->
<!--            <div>{{scope.row.columnName}}</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </el-table>-->

    </div>
    <div slot="footer" class="dialog-footer">
      <!--<div class="fl">-->
        <!--<el-checkbox v-model="isShowAll" @click.native.stop="handleSelection()" true-label="true" false-label="false"></el-checkbox>&nbsp;显示全部列字段-->
      <!--</div>-->
      <!--<div class="fl" style="margin-left: 5px">-->
        <!--<el-checkbox v-model="isSelectAll" @click.native.stop="selectAll()" true-label="true" false-label="false"></el-checkbox>&nbsp;全选-->
      <!--</div>-->
      <xr-button type="primary" @click.native="save()">同步导出</xr-button>
      <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken } from '@/utils/auth'
import request from "../../utils/request";

export default {
    //表格配置
    name: "tableColumn-setting",
    data() {
      return {
        dialogVisible: false,                              //是否显示
        dialogName: '选择导出列',
        id: '',                                             //表格的ID
        isShowAll: false,                                  //显示全部
        isSelectAll: false,                                //选择全部
        tableData: [],                                      //数据数组
        configure: new Object(),                           //表格配置
        exportType: '2',                                    //导出类型
        exportTypeList: [                                   //导出类型列表
          {label:'导出本页',value:'1'},
          {label:'导出全部',value:'2'},
          // {label:'导出选中数据',value:'3'}
        ],
        dataConfigure: {
          defaultNoLoadData: true,
          isSelectFirst: false,
          isShowToolbar: false,
          pagination: false,
          idField: 'tableColumn',
          tableHeight: '380px',
          columns: [
            {
              field: 'ck',
              width: 60,
            },
            {
              field: 'columnName',
              title: '列名称',
              condition: {
                searchType: 'input',
                searchName: 'columnNameSearch',
                value:''
              },
            },
          ],
          toolbar: [],
          tableData:[   //数据列表

          ]
        },
        query:'',                                          //返回查询信息和页数
        userName:''                                        // 用户名
      }
    },
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    methods: {
      //初始化页面
      init(configure, query) {
        this.dialogVisible = true;
        this.configure = configure;
        this.query = query;
        this.userName = this.$store.state.user.name
        let tableDate = [];
        let columns = configure.columns
        for (let i = 0; i < columns.length; i++) {
          let temp = columns[i];
          if(temp.field == 'ck' || temp.field == 'sn'){   //清除掉无用的内容
            continue;
          }
          let obj = new Object();
          obj['tableColumn'] = temp.field;
          obj['columnName'] = temp.title;
          // obj['isShow'] = '1';
          obj['checked'] = false;
          tableDate.push(obj)
        }
        this.dataConfigure.tableData = tableDate;
      },
      //确认
      save() {
        // 放入选择的列
        let newColumns = [];
        let fieldStr = ',';
        let list = this.dataConfigure.tableData;
        let columns = this.configure.columns;
        for (let i = 0; i < list.length; i++) {
          if(list[i]['checked'] === true){
            fieldStr += list[i]['tableColumn'] + ',';
          }
        }

        for (let i = 0; i < columns.length; i++) {
          if(fieldStr.indexOf(',' + columns[i].field + ',') != -1){
            if(!!columns[i].that){
              delete columns[i].that;
            }
            let singleColumn = columns[i]
            newColumns.push(singleColumn);
          }
        }

        console.log('1111111');
        console.log(JSON.stringify(newColumns));

        let name = '数据列表';
        if(!!this.configure.name){
          name = this.configure.name
        }

        let orgId = localStorage.getItem("orgId");

        let obj = new Object();
        obj['accessToken'] = getToken();
        obj['exportType'] = this.exportType;
        obj['service_key'] = this.configure.url.replace('/web/service?method=', '').split('&')[0];
        obj['name'] = name;
        let data = this.CommonUtils.createFormData(obj);
        data.append("columns", JSON.stringify(newColumns));
        data.append("query", JSON.stringify(this.query));
        data.append("orgId", orgId);


        const fileName =  name +  '-'+ this.getThisTime() + '.xlsx'

        return this.request({
          method:'post',
          url:'/web/exportData',
          responseType: 'arraybuffer',
          data: data
        }).then((response) =>{
          if(response != null ){
            let blob = new Blob([response], {
              type: `application/msexcel`
            });
            let objectUrl = URL.createObjectURL(blob);
            let link = document.createElement("a");
            // let fname = `默认导出结果.xlsx`; //下载文件的名字
            link.href = objectUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(link.href)
          }else {
            this.$message({
              type: "error",
              message: "导出失败"
            })
          }
        })
      },


      // 获取当前时间
      getThisTime(){
        var currentDate = new Date();

        var year = currentDate.getFullYear();     // 获取当前年份
        var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');         // 获取当前月份并补零
        var day =  (currentDate.getDate() + 1).toString().padStart(2, '0');           // 获取当前日期
        var hour = (currentDate.getHours() + 1).toString().padStart(2, '0');          // 获取当前小时数
        var minute = (currentDate.getMinutes() + 1).toString().padStart(2, '0');      // 获取当前分钟数
        var second = (currentDate.getSeconds() + 1).toString().padStart(2, '0');      // 获取当前秒数

        return year + month + day
        // return year + month + day + hour + minute + second
      },
      getUserInfo() {
        this.userInfo.userId = this.$store.state.user.userId
        this.userInfo.realname = this.$store.state.user.name

        this.request({
          method:'post',
          url:'/web/service?method=tCoreUser_getUserInfo',
        }).then((response) =>{
          if (response && response.code === 0) {
            this.userName = response.data.user.userName
          }
        })
      },

    }
}
</script>

<style scoped>
  .tableExport-div{height: 430px;width: 290px;margin: 5px}
  .tableExport-form{}
  .tableExport-form .el-form{padding: 0px !important;}
</style>



// WEBPACK FOOTER //
// src/components/XrTable/tableExport.vue